// extracted by mini-css-extract-plugin
export var card = "index-module--card--226f8";
export var grid = "index-module--grid--d72f3";
export var gridTitle = "index-module--gridTitle--a8b7a";
export var imageLabel = "index-module--imageLabel--b2382";
export var info = "index-module--info--8ea30";
export var link = "index-module--link--b37ad";
export var viewProduct = "index-module--viewProduct--3b2b1";